import React, { useEffect, useState } from 'react';
import { makeStyles } from '@material-ui/styles';
import { MembershipHeader, MembershipTypes } from './components';
import { actionGetMembershipPackage, actionGetMembershipPackages } from 'actions';
import { useSelector, useDispatch } from 'react-redux';
import { genfunction } from '../../helpers';
import ErrorHandling from '../../components/ErrorHandling/ErrorHandling';

const { Membershipheadernewmsg, Membershipheaderrenewmsg, MembershipPackagesDisplayAreaNo, PurchaseMembershipNotAllowedForOrganizationBooking } = window['runConfig'];

const useStyles = makeStyles(theme => ({
    root: {
        // padding: theme.spacing(2),
        [theme.breakpoints.up('sm')]: {
            // marginTop: theme.spacing(5)
        }
    }
}));

const Memberships = (props) => {

    const classes = useStyles();

    const constnextredirect = () => {
        props.history.push({
            pathname: '/checkout'
        })
    }

    let shopcartmember = false;
    let membershipPackage;
    let isRenewPackage = false;

    const [colorState, setColorState] = React.useState('');
    const [error, seterror] = useState("");
    const events = useSelector(state => state.reducerShopCart.events);

    const dispatch = useDispatch();

    const GetMemberShip = () => {

        let membership;

        if (membershippackagesreducer.membershipPackage && membershippackagesreducer.membershipPackage.MembershipPackageID == props.match.params.id) {
            membership = membershippackagesreducer.membershipPackage;

            if (props.match.path == "/memberships/join/:id") {
                //original shopcartmember = false;
                shopcartmember = true;

            }
            else {
                shopcartmember = true;
            }
        }
        else if (membershipPackages && membershipPackages.length > 0 && membershipPackages.find(x => x.MembershipPackageID == parseInt(props.match.params.id)) !== undefined) {
            membership = membershipPackages.find(x => x.MembershipPackageID == props.match.params.id);
            shopcartmember = true;
        }
        else {
            membership = membershippackagesreducer.membershipPackage;
            shopcartmember = false;
        }

        if (props.match.path == "/memberships/renew/:id") {
            isRenewPackage = true;
        }

        return membership;
    }


    const membershipPackages = useSelector(state => state.reducerShopCart.MembershipPackages);
    const membershippackagesreducer = useSelector(state => state.reducerMembershipPackages);

    membershipPackage = GetMemberShip();

    useEffect(() => {

        if (props.match.path == "/memberships/join/:id" && !genfunction.IsArrayNotEmptyNullUndefined(membershippackagesreducer.membershippackages))
            actionGetMembershipPackages(dispatch, MembershipPackagesDisplayAreaNo);
    }, [])

    useEffect(() => {

        if (props.match.path === "/memberships/join/:id" && genfunction.IsArrayNotEmptyNullUndefined(membershippackagesreducer.membershippackages) &&
            (!membershippackagesreducer.membershipPackage || Object.keys(membershippackagesreducer.membershipPackage).length === 0)) {
            JoinMembershipPage(props.match.params.id);
        }

    }, [membershippackagesreducer.membershippackages]);

    const errorcancelhandle = () => seterror('');

    const JoinMembershipPage = (membership) => {
        {
            if (membershipPackages && membershipPackages.length > 0 && membershipPackages.filter(x => x.MembershipPackageID == membership).length == 0) {
                seterror('You already have one membership package in your cart!');
            }
            else if (genfunction.IsOrganization(events)) {
                setColorState('info');
                seterror(PurchaseMembershipNotAllowedForOrganizationBooking);
            }
            else {
                actionGetMembershipPackage(dispatch, props.match.params.id);
            }
        }
    }

    const GetMembershipTypes = () => {
        let membershipTypesID = "";
        if (membershipPackage && membershipPackage.MembershipProducts && membershipPackage.MembershipProducts.length > 0) {
            membershipPackage.MembershipProducts.filter(x => x.MembershipType === "Membership").map(m => {

                if (membershipTypesID.length == 0) {
                    membershipTypesID += m.MembershipTypeID;
                }
                else {
                    membershipTypesID += "," + m.MembershipTypeID;
                }
            });
        }

        return membershipTypesID;
    }

    return (

        <div id="vt_page_membership" className={classes.root}>
            <ErrorHandling color={colorState} msg={error.length > 0 ? error : ''}
                open={error.length > 0 ? true : false} handleclose={errorcancelhandle} />
            <MembershipHeader membershipPackage={membershipPackage} displayMsg={isRenewPackage ? Membershipheaderrenewmsg : Membershipheadernewmsg} isRenew={isRenewPackage} />
            <MembershipTypes
                membershipTypeIDs={GetMembershipTypes()}
                membershipPackage={membershipPackage}
                shopcartmember={shopcartmember}
                constnextredirect={constnextredirect}
                isRenewPackage={isRenewPackage}  {...props}
                membershipPackageID={parseInt(props.match.params.id)}
            />


        </div>
    );
};

export default Memberships;
